import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Button,
  useToast,
} from "@chakra-ui/react";
import ProductItem from "./ProductItem";
import { arrayToOption } from "../../../Utils/formatUtils";
import ConfirmationSwal from "../../../Utils/confirmationSwal";
import { ProductsContext } from "../../Context/ProductsContext";
import useFetch from "../../../hooks/useFetch";
import ContentCard from "../../Common/Layout/ContentCard";

const ProductList = ({
  orderProducts,
  setProducts,
  editable,
  orderId,
  priceListsProducts,
  setIsEdited = () => {},
}) => {
  const { products, getProducts, isLoadingProduct } =
    useContext(ProductsContext);
  const [showNewProduct, setShowNewProduct] = useState(false);
  const { post, del, put } = useFetch();
  const toast = useToast();

  const setProductOptions = () => {
    return arrayToOption(priceListsProducts, "id", "name", "brand");
  };

  useEffect(() => {
    getProducts({ orderBy: "productName" });
  }, []);

  const editProduct = async (product, action = "edit") => {
    let newProducts = [...orderProducts];

    let index = orderProducts.findIndex((prod) => product.id == prod.id);

    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        if (index === -1) {
          // new
          if (!isNaN(orderId)) {
            await post(`/orders/${orderId}/products`, product)
              .then((res) => {
                setProducts(res);
              })
              .catch((e) => {
                toast({
                  title: "Se ha producido un error.",
                  description:
                    e?.message || "Contacte con el administrador del sistema.",
                  status: "error",
                  duration: 4000,
                  isClosable: true,
                });
              });
          } else {
            newProducts = [product, ...orderProducts];
            setProducts(newProducts);
          }
        } else {
          //edit
          if (!isNaN(orderId)) {
            await put(`/orders/${orderId}/products/${product.id}`, product)
              .then((res) => {
                newProducts[index] = product;
                setProducts(newProducts);
              })
              .catch((e) => {
                toast({
                  title: "Se ha producido un error.",
                  description:
                    e?.message || "Contacte con el administrador del sistema.",
                  status: "error",
                  duration: 4000,
                  isClosable: true,
                });
              });
          } else {
            newProducts[index] = product;
            setProducts(newProducts);
          }
        }
        break;

      case "delete":
        let text = `¿Esta seguro que desea eliminar el articulo ${product.name}?`;

        ConfirmationSwal.fire({
          title: "Eliminar artículo",
          text: text,
          icon: "question",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await del(`/orders/${orderId}/products/${product.id}`)
              .then((res) => {
                newProducts.splice(index, 1);
                setProducts(newProducts);
              })
              .catch((e) => {
                toast({
                  title: "Se ha producido un error.",
                  description:
                    e?.message || "Contacte con el administrador del sistema.",
                  status: "error",
                  duration: 4000,
                  isClosable: true,
                });
              });
          }
        });

        break;
    }
    setShowNewProduct(false);
  };

  const cancelNewProduct = () => {
    setShowNewProduct(false);
  };

  return (
    <ContentCard>
      <Heading variant="h2">Artículos</Heading>
      <Button
        my="2"
        colorScheme="blue"
        onClick={() => setShowNewProduct(true)}
        isDisabled={
          !editable ||
          showNewProduct ||
          (priceListsProducts && !priceListsProducts.length)
        }
      >
        + Artículo
      </Button>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em" textAlign="center">
                Cantidad
              </Th>
              <Th fontSize="0.8em">Articulo</Th>
              <Th fontSize="0.8em" textAlign="center">
                Precio ($)
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Descuento (%)
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Total ($)
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Stock
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          {!isLoadingProduct && (
            <Tbody>
              {showNewProduct && (
                <ProductItem
                  product={{}}
                  productOptions={setProductOptions()}
                  userProductList={priceListsProducts}
                  products={products}
                  orderProducts={orderProducts}
                  cancelNewProduct={cancelNewProduct}
                  editProduct={editProduct}
                  initialAction={"new"}
                  setIsEdited={setIsEdited}
                />
              )}
              {orderProducts.map((product) => (
                <ProductItem
                  key={product.id}
                  product={product}
                  productOptions={setProductOptions()}
                  products={products}
                  userProductList={priceListsProducts}
                  orderProducts={orderProducts}
                  editable={editable}
                  editProduct={editProduct}
                  setIsEdited={setIsEdited}
                />
              ))}
            </Tbody>
          )}
        </Table>
      </Box>{" "}
    </ContentCard>
  );
};

export default ProductList;
